import {EntityHistory} from "./EntityHistory";
import ResidencyUses from "./enums/ResidencyUses.js";
import {findEntityById, toFullEntityResult} from "./helpers/toFullEntityResult";
import {ResidencyId} from "./nominalTypes/ResidencyId";
import {ZoneId} from "./nominalTypes/ZoneId";
import {AllPermitsResult} from "./types/AllPermitsResult";
import {FullEntityRelation} from "./types/EntityRelation";
import {PermitEntityResult, PermitFullEntityResult} from "./types/PermitEntityResult";
import {ResidencyResult} from "./types/ResidencyResult";

function createEmptyResidency(residencyId: ResidencyId): ResidencyResult {
	return {
		id: residencyId,
		uses: ResidencyUses.None,
		address: {street: residencyId, streetNumber: "—"},
		zoneId: "" as ZoneId,
		customData: [],
		attachments: []
	}
}

class Residencies {
	static get(permits: AllPermitsResult, id: ResidencyId): ResidencyResult {
		return findEntityById(permits.residencies, id, createEmptyResidency);
	}

	static getAll(permits: AllPermitsResult, ids: ResidencyId[]): ResidencyResult[] {
		return ids.map(id => this.get(permits, id));
	}

	static getChanged(permits: AllPermitsResult, residency: PermitEntityResult<ResidencyId>[]): FullEntityRelation<ResidencyId, ResidencyResult> | undefined {
		const c = EntityHistory.changed(residency);
		if (!c) {
			return;
		}

		const {original, changed} = c;
		return {
			original: toFullEntityResult(permits.residencies, original, createEmptyResidency),
			changed: changed && toFullEntityResult(permits.residencies, changed, createEmptyResidency)
		};
	}

	static getValid(permits: AllPermitsResult, residency: PermitEntityResult<ResidencyId>[]): PermitFullEntityResult<ResidencyId, ResidencyResult> | undefined {
		const e = EntityHistory.approvedOrDefault(residency);
		if (e == null) {
			return;
		}
		return toFullEntityResult(permits.residencies, e, createEmptyResidency);
	}
}

export {Residencies};
